import domainConfig from 'app/PoC/DataGridDemoPages/ActivityRecordsDemo/ActivityRecordDemo.config'
import SkyNetObjectProfile from 'app/shared-components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from 'app/shared-components/SkyBaseDataGrid'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const ActivityRecordsDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={domainConfig}
            featuresLists={featuresLists}
        />
    )
}

export default ActivityRecordsDemoPage
